import * as React from "react";
import { Route, Routes, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";

import { AboutPage, BookingPage, ChangePasswordPage, DashboardPage, DataDeletionRequestsPage, GetInTouchPage, MyBookingsPage, MyGuestsPage, MyQuotesPage, PrivacyStatementPage, ProfilePage, QuotePage, TermsAndConditionsPage } from "../pages";
import { history } from "../app-history";
import routes from "./routes";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import {
  ReactPlugin,
  AppInsightsContext,
} from "@microsoft/applicationinsights-react-js";
import { useContext } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { AppContainer } from "../components/app-container";

var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: "fdcb4e4f-bb7c-4ba5-ac0e-4ff296e36cd1", // appConfig.appInsightsKey,
    isCookieUseDisabled: true,
    isStorageUseDisabled: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: history },
    },
  },
});
appInsights.loadAppInsights();

// Proactively delete any existing cookies (across common paths).
  const kill = (name: string) => {
    const past = 'Thu, 01 Jan 1970 00:00:00 GMT';
    // Current host
    document.cookie = `${name}=; expires=${past}; path=/;`;
    // Root domain (handles subdomains like www.)
    const parts = window.location.hostname.split('.');
    if (parts.length > 1) {
      const root = `.${parts.slice(-2).join('.')}`;
      document.cookie = `${name}=; expires=${past}; path=/; domain=${root};`;
    }
  };
  kill('ai_user');
  kill('ai_session');

interface IProps {
  children: React.ReactNode;
}

const AppInsightsContextProvider = ({ children }: IProps) => {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
};

export const useAppInsightsContext = () => useContext(AppInsightsContext);


export const AppRouter = () => {
  return (
    <HistoryRouter history={history as any}>
      <AppInsightsContextProvider>
        <AppContainer>
          <Routes>
            <Route path={routes.home()} element={<><DashboardPage /></>} />
            <Route path={routes.quotes()} element={<><MyQuotesPage /></>} />
            <Route path={routes.bookings()} element={<><MyBookingsPage /></>} />
            <Route path={routes.guests()} element={<><MyGuestsPage /></>} />
            <Route path={routes.getInTouch()} element={<><GetInTouchPage /></>} />
            <Route path={routes.getInTouchHolidayRequest(':type', ':bookingId')} element={<><GetInTouchPage /></>} />
            <Route path={routes.getInTouchRequest(':type')} element={<><GetInTouchPage /></>} />
            <Route path={routes.about()} element={<><AboutPage /></>} />
            <Route path={routes.termsAndConditions()} element={<><TermsAndConditionsPage /></>} />
            <Route path={routes.profile()} element={<><ProfilePage /></>} />
            <Route path={routes.quote(':quoteId')} element={<><QuotePage /></>} />
            <Route path={routes.booking(':bookingId')} element={<><BookingPage /></>} />
            <Route path={routes.changePassword()} element={<><ChangePasswordPage /></>} />
            <Route path={routes.dataDeletionRequests()} element={<><DataDeletionRequestsPage/></>} />
            <Route path={routes.privacyStatement()} element={<><PrivacyStatementPage/></>} />
          </Routes>
        </AppContainer>
      </AppInsightsContextProvider>
      <StyledContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </HistoryRouter>
  );
};

const StyledContainer = styled(ToastContainer).attrs({
  // custom props
})`
  .Toastify__toast-container {
  }
  .Toastify__toast {
    border-radius: 0;
  }
  .Toastify__toast--error {
  }
  .Toastify__toast--warning {
  }
  .Toastify__toast--success {
  }
  .Toastify__toast-body {
  }
  .Toastify__progress-bar {
  }
`;

export { reactPlugin };


